import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRubyComponent } from './simple-icons-ruby.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRubyComponent ],
    exports:      [ SimpleIconsRubyComponent ],
    bootstrap:    []
})
export class SimpleIconsRubyModule {}
